import React from "react";
import { Box, Typography, Paper, Divider } from "@mui/material";
import { motion } from "framer-motion";
import TranscriptionInstructions from "../TranscriptionInstructions/TranscriptionInstructions";

const TranscriptionHome = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <Box
        sx={{
          width: "auto",

          padding: "0px 20px",
          margin: "0px auto",
          padding: { xs: "20px", sm: "30px", md: "1px 80px" },
          border: "none",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            marginBottom: "30px",
            textAlign: "left",
          }}
        ></Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: "5px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          Welcome to the Mississippi Digital Humanities Hub transcription tool!
          We appreciate your help transcribing documents. Transcription makes
          documents easier to search and easier to discover.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "5px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          These instructions are for Southern Miss transcriptions. If you are
          working on a project for a different institution, they may have their
          own guidelines.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "10px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          Documents are transcribed and reviewed by volunteers. It takes at
          least one volunteer to transcribe a page and at least one different
          volunteer to review and mark it complete. Review ensures
          transcriptions are whole and accurate. Complex documents may pass
          through transcription and review several times before they are
          completed.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          In order to access the transcription portal, please sign up or log in{" "}
          <a href="/dh-hub">here</a>.
        </Typography>
      </Box>
      <TranscriptionInstructions />
    </motion.div>
  );
};

export default TranscriptionHome;
